import { buildApiUrl, API_ENDPOINTS } from '@/constants';
import { createContext, FC, PropsWithChildren, useContext, useEffect, useState } from 'react';

interface Category {
  id: string;
  name: string;
  prompt_count?: number;
}

interface CategoryContextProps {
  categories: Category[];
  loading: boolean;
}

const CategoryContext = createContext<CategoryContextProps | undefined>(undefined);

export const CategoryProvider: FC<PropsWithChildren> = ({ children }) => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const url = buildApiUrl(API_ENDPOINTS.CATEGORIES.WITH_COUNT);
        const response = await fetch(url);
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        // Silently handle category fetch errors
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return (
    <CategoryContext.Provider value={{
      categories,
      loading,
    }}
    >
      {children}
    </CategoryContext.Provider>
  );
};

export const useCategories = () => {
  const context = useContext(CategoryContext);
  if (!context) {
    throw new Error('useCategories must be used within a CategoryProvider');
  }
  return context;
};
